import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'textHighlight' })
export class TextHighlightPipe implements PipeTransform {
    transform(value: string | string[]): string | string[] {
        if (!value) {
            return value;
        }
        return value.toString().replace(/<mark>/gi, '<span class="highlight">').replace(/<\/mark>/gi, '</span>');
    }
}
